import React from 'react'

import { PopularItem } from './PopularItem/PopularItem'
import Progress from '../Progress/Progress'
import { usePopularItems } from '../../hooks/use-popular-items'

import Star from '../../assets/star.svg'
import { dataByTypename } from '../../utils/apollo-helpers'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

import './PopularItems.css'

export const PopularItems = () => {
  const { restaurantInfo } = useRestaurant()

  let enabled = false

  if (
    restaurantInfo.data &&
    restaurantInfo.data.restaurant &&
    restaurantInfo.data.restaurant.popularItemsConfig
  ) {
    enabled = Boolean(restaurantInfo.data.restaurant.popularItemsConfig.enabled)
  }

  const { loading, error, data } = usePopularItems()

  if (!enabled || error) return null

  if (loading) return <Progress eventData={{ category: 'PopularItems' }} />

  const { PopularItemsResponse } = dataByTypename(data.popularItems)
  if (!PopularItemsResponse) return null
  const { items } = PopularItemsResponse
  if (items.length === 0) return null

  return (
    <div styleName='popularItems'>
      <div styleName='wrap'>
        <h2 styleName='header'>
          <Star styleName='star' />
          Popular Items
        </h2>
        <ul styleName='items'>
          {items.map(item => (
            <PopularItem item={item} key={item.guid} />
          ))}
        </ul>
      </div>
    </div>
  )
}
